export const enum PasswordTopic {
    ADMIN = 'react/admin_password',
    LOCO = 'react/loco_password',
};
